import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { SupplierRequestDraftItem } from '../model/types';
import RequestItemsTableBody from './RequestItemsTableBody';

interface RequestItemsTableProps {
    items: SupplierRequestDraftItem[];
    editCountIndex?: number | null;
    setEditCountIndex?: (index: number | null) => void;
    onSaveCount?: (index: number, value: string | number) => void;
    onRemove?: (index: number) => void;
    disabled?: boolean;
    showActions?: boolean;
    showReceived?: boolean;
}

const RequestItemsTable = ({
    items,
    editCountIndex = null,
    setEditCountIndex = () => undefined,
    onSaveCount = () => undefined,
    onRemove = () => undefined,
    disabled = false,
    showActions = true,
    showReceived = false,
}: RequestItemsTableProps) => {
    const { t } = useTranslation(['Vendors']);

    return (
        <div className="crm-table-wrap supplier-request-items-table-wrap">
            <Table size="sm" className="mb-0 align-middle supplier-request-items-table">
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">{t('supplierRequests.create.colName')}</td>
                        <td className="head-article">{t('supplierRequests.create.colArticle')}</td>
                        <td className="head-object">{t('supplierRequests.create.colObject')}</td>
                        
                        <td className="head-count text-end">{t('supplierRequests.create.colCount')}</td>
                        {showReceived && (
                            <td className="head-count text-end">
                                {t('supplierRequests.create.colReceived')}
                            </td>
                        )}
                        <td className="head-dimension text-end">
                            {t('supplierRequests.create.colDimension')}
                        </td>
                        {showActions && (
                            <td className="head-action text-end">
                                {t('supplierRequests.create.colActions')}
                            </td>
                        )}
                    </tr>
                </thead>
                <RequestItemsTableBody
                    items={items} 
                    editCountIndex={editCountIndex}
                    setEditCountIndex={setEditCountIndex}
                    onSaveCount={onSaveCount}
                    onRemove={onRemove}
                    disabled={disabled}
                    showActions={showActions}
                    showReceived={showReceived}
                />
            </Table>
        </div>
    );
};

export default RequestItemsTable;
